import * as Hammer from 'hammerjs';

import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';

@Injectable()
export class SnHammerGestureConfig extends HammerGestureConfig {
  public events = ['doubletap', 'longpress', 'swipe'];

  public buildHammer(element: HTMLElement): HammerManager {
    const hammer = super.buildHammer(element) as HammerManager;

    const longpress = new Hammer.Press({ event: 'longpress', time: 500 });
    hammer.add(longpress);

    return hammer;
  }
}
